import { Fragment } from 'react'

import { Box, Typography } from '@mui/material'

interface Props {
  rows: string[]
}

export function NotificationBody(props: Props) {
  const { rows } = props

  return (
    <Box
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }}
    >
      <Typography variant="body1">
        {rows.map((item, key) => (
          <Fragment key={key}>
            {item}
            <br />
          </Fragment>
        ))}
      </Typography>
    </Box>
  )
}
